import { internalInstance } from 'v5/i18n.internal';
import type { ResourceKinds } from 'v5/core/entity-values/values.types';
import { createResourceFormKit } from 'v5/patterns/forms/schema-form/fields/resourceFormKit';
import { createResourceIssueMessage } from 'v5/patterns/forms/schema-form/fields/resourceIssueMessage';
import type { FormKit } from 'v5/patterns/forms/schema-form/schemaForm.types';
import { ShortlistYesNoField } from './ShortlistYesNoField';

/** A service hook the display never reaches: failing loudly beats a silent empty result. */
function unavailable(name: string) {
  return (): never => {
    throw new Error(`${name} is not available in the shortlist display`);
  };
}

/** The display never searches, creates or opens anything: the service-bound parts of the config are inert. */
const resourceKit = createResourceFormKit(
  {
    contactDetails: { useDefaultCountry: unavailable('useDefaultCountry') },
    locations: { useLocations: unavailable('useLocations') },
    entityRef: {
      resource: {
        noun: 'resource',
        useOption: unavailable('entityRef.useOption'),
        useOptions: unavailable('entityRef.useOptions'),
        useCreate: unavailable('entityRef.useCreate'),
        open: unavailable('entityRef.open'),
        usePageHref: unavailable('entityRef.usePageHref'),
        useCard: unavailable('entityRef.useCard'),
        onPick: unavailable('entityRef.onPick')
      }
    },
    groups: { renderSelectedValue: undefined },
    netsuite: {
      useMasterProjects: unavailable('netsuite.useMasterProjects')
    }
  },
  createResourceIssueMessage(internalInstance)
);

/** The resource kit, with a boolean read as Yes / No. */
export const shortlistDisplayKit: FormKit<ResourceKinds> = {
  ...resourceKit,
  boolean: { ...resourceKit.boolean, Component: ShortlistYesNoField }
};
